/* eslint-disable prettier/prettier */
import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

const Progress = React.forwardRef(function Progress(
  { className, value = 0, max = 100, ...props },
  ref,
) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={value}
      className={cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className)}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - percentage}%)` }}
      />
    </div>
  );
});

Progress.displayName = 'Progress';

Progress.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  max: PropTypes.number,
};

Progress.defaultProps = {
  className: '',
  value: 0,
  max: 100,
};

// eslint-disable-next-line import/prefer-default-export
export { Progress };
